import React from "react";
import {
    FilesPdfColoredIcon,
    WordColorIcon,
    ExcelColorIcon,
    FilesGenericColoredIcon,
    FilesTextColoredIcon,
    PowerPointColorIcon,
    FilesPictureColoredIcon,
    FilesVideoIcon,
} from "@fluentui/react-icons-northstar";

const wordExtensions = ["docx", "doc", "rtf", "odt"];
const excelExtensions = ["csv", "xls", "xlsx", "ods"];
const powerPointExtensions = ["pps", "ppt", "pptx"];
const imagesExtensions = ["bmp", "png", "jpg", "jpeg", "gif"];
const moviesExtensions = ["avi", "mp4"];

export function mapExtensionToTeamsIcon(extension: string) {
    switch (extension) {
        case "pdf":
            return <FilesPdfColoredIcon />;
        case "txt":
            return <FilesTextColoredIcon />;
    }

    if (wordExtensions.includes(extension)) {
        return <WordColorIcon />;
    }

    if (excelExtensions.includes(extension)) {
        return <ExcelColorIcon />;
    }

    if (powerPointExtensions.includes(extension)) {
        return <PowerPointColorIcon />;
    }

    if (imagesExtensions.includes(extension)) {
        return <FilesPictureColoredIcon />;
    }

    if (moviesExtensions.includes(extension)) {
        return <FilesVideoIcon />;
    }

    return <FilesGenericColoredIcon />;
}

export function calculateFileSize(fileSize: number) {
    return fileSize / Math.pow(1024, 2);
}
